module.exports = __webpack_public_path__ + "static/media/gps_fixed.d5868e4d.svg";